import React, {Fragment} from 'react'
import Select from "react-select";
import DropdownIndicator from './components/global/DropdownIndicator';
import SingleValue from './components/select-normal/SingleValue';
import Menu from './components/select-normal/Menu';
import MenuList from './components/select-normal/MenuList';
import Option from './components/select-normal/Option';
import '../../../assets/sass/components/react-select.scss';
import SelectBase from "./components/global/SelectBase";

class SelectNormal extends SelectBase {

    render() {
        return (
            <Fragment>
                <Select
                    {...this.props}
                    classNamePrefix="react-select"
                    className={ this.setClasses(this.props, 'select-normal') }
                    options={this.props.options}
                    isSearchable={false}
                    arrowAutoPlacement={this.arrowAutoPlacement}
                    components={{
                        Menu,
                        MenuList,
                        Option,
                        DropdownIndicator,
                        SingleValue,
                        IndicatorSeparator: () => null
                    }}
                />
            </Fragment>
        )
    }
}

export default SelectNormal;